import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

const FAQData = [
  {
    questNo: 1,
    quest: "Why is there only one plan in the UK?",
    response:
      "We’ve launched with a single Pro plan at a limited time offer of £200/month to make it simple for brands to get started. As we expand features, additional plans will be introduced.",
  },
  {
    questNo: 2,
    quest: "Which channels are supported today?",
    response:
      "Currently, WhatsApp is fully supported for campaigns, automations, and customer engagement. Facebook, Instagram, and chat panel features are on our roadmap and will be available soon.",
  },
  {
    questNo: 3,
    quest: "Do I need technical expertise to set up Kwik Engage?",
    response:
      "Not at all. Kwik Engage is no-code and easy to set up. You can launch WhatsApp broadcasts and automations in minutes, without needing a developer.",
  },
  {
    questNo: 4,
    quest: "How does Kwik Engage help me recover carts?",
    response:
      "Our AI-powered calling and WhatsApp chat follow up with shoppers who abandon their carts, reminding them to complete checkout and driving more recovered revenue.",
  },
  {
    questNo: 5,
    quest: "Is my data secure with Kwik Engage?",
    response:
      "Yes. We are PCI DSS certified, which means your data and payment interactions are handled with the highest level of security.",
  },
  {
    questNo: 6,
    quest: "What kind of support will I get?",
    response:
      "Every brand on the Pro plan is assigned a dedicated Customer Success Manager (CSM) to help with setup, optimisation, and ongoing growth.",
  },
  {
    questNo: 7,
    quest: "Is there a free trial?",
    response:
      "Yes. We offer a 14-day free trial so you can experience Kwik Engage in action before committing.",
  },
  {
    questNo: 8,
    quest: "How quickly will I see results?",
    response:
      "Most brands begin seeing an uplift in recovered carts and engagement within 2–4 weeks of using Kwik Engage.",
  },
];

const SectionFour = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Decide how many items to show
  const visibleFAQs = showAll ? FAQData : FAQData.slice(0, 4);

  return (
    <div className="section-four-price-faq-inter">
      <div
        style={{
          minHeight: "70vh",
          padding: "0",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: "700px",
            margin: isMobile ? "0 20px" : "0px auto",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              color: "#000",
              fontSize: !isMobile ? "44px" : "24px",
              fontWeight: 700,
              marginBottom: "24px",
              // fontFamily: "Inter, Arial, sans-serif"
            }}
          >
            Frequently Asked Questions
          </h1>
          <p
            style={{
              textAlign: "center",
              color: "#000",
              fontSize: !isMobile ? "18px" : "14px",
              fontWeight: 400,
              // fontFamily: "Inter, Arial, sans-serif"
            }}
          >
            Have questions about Kwik Engage? We've got answers. Learn more
            about our platform's ease of use, integration capabilities, and
            dedicated support system.
          </p>

          <div>
            {visibleFAQs.map((faq, idx) => (
              <div
                key={faq.questNo}
                style={{
                  background: "#fff",
                  borderRadius: "7px",
                  boxShadow: "0 1px 2px 0 rgba(16,24,40,0.04)",
                  marginBottom: "16px",
                  overflow: "hidden",
                  border: "1px solid #eee",
                  marginTop: "15px",
                }}
              >
                <button
                  style={{
                    width: "100%",
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    padding: 0,
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                  onClick={() => toggleAccordion(idx)}
                  aria-expanded={activeIndex === idx}
                  aria-controls={`faq-response-${idx}`}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                      color: "#111",
                      padding: "18px 20px",
                      // fontFamily: "Inter, Arial, sans-serif"
                    }}
                  >
                    <span>{faq.quest}</span>
                    <span
                      style={{
                        marginLeft: "20px",
                        color: "#222",
                        fontSize: "19px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {activeIndex === idx ? <FiMinus /> : <FaPlus />}
                    </span>
                  </div>
                </button>
                <div
                  id={`faq-response-${idx}`}
                  style={{
                    maxHeight: !isMobile
                      ? activeIndex === idx
                        ? "200px"
                        : "0"
                      : activeIndex === idx
                      ? "220px"
                      : "0",
                    overflow: "hidden",
                    background: "#fff",
                    transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                    padding:
                      activeIndex === idx ? "0 20px 16px 20px" : "0 20px",
                    opacity: activeIndex === idx ? 1 : 0,
                    fontSize: "1.05rem",
                    color: "#333",
                  }}
                >
                  {activeIndex === idx && (
                    <div style={{ paddingTop: "4px", paddingBottom: "2px" }}>
                      {faq.response}
                    </div>
                  )}
                </div>
              </div>
            ))}

            {/* See More Button */}
            {FAQData.length > 4 && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="start-now-btn"
                 
                >
                  {showAll ? "See Less" : "See More"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
